<template>
  <nav class="wrapper-relative">
    <div class="wrapper-absolute">
      <div class="wrapper-fixed">
        <div class="title" ref="home">
          <router-link to="/" @click="reset">Hugo Cohen</router-link>
        </div>
        <div class="main-menu">
          <ul class="menu" ref="menu">
            <li>
              <router-link class="main-menu-item" @click="toggle" to="/photo">Photo</router-link>
            </li>
            <li>
              <router-link class="main-menu-item" @click="toggle" to="/video">Video</router-link>
            </li>
            <li>
              <router-link class="main-menu-item" @click="toggle" to="/about">About</router-link>
            </li>
          </ul>
          <div class="menu-toogle">
            <div v-if="toggleMenu">
              <font-awesome-icon :icon="menuIcons.bars" @click="toggle"></font-awesome-icon>
            </div>
            <div v-else>
              <font-awesome-icon :icon="menuIcons.cross" @click="toggle"></font-awesome-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, onBeforeUnmount } from "vue";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";

export default defineComponent({
  name: "Navigation",
  setup() {
    const menu = ref<HTMLUListElement>();
    const home = ref<HTMLDivElement>();
    const showNavbar = ref(true);
    const lastScrollPos = ref(0);
    const toggleMenu = ref(true);
    const menuIcons = {
      bars: faBars,
      cross: faTimes,
    };

    const onScroll = () => {
      const currentScrollPos =
        window.pageXOffset || document.documentElement.scrollTop;
      if (Math.abs(currentScrollPos - lastScrollPos.value) < 60) {
        return;
      }

      showNavbar.value = currentScrollPos < lastScrollPos.value;
      lastScrollPos.value = currentScrollPos;
    };

    const reset = () => {
      if (document.documentElement.clientWidth > 768) return;
      toggleMenu.value = true;
      if (menu.value) {
        menu.value.style.visibility = "hidden";
        menu.value.style.opacity = "0";
      }
    };

    const toggle = () => {
      if (document.documentElement.clientWidth > 768) return;
      if (menu.value) {
        menu.value.style.visibility = toggleMenu.value ? "visible" : "hidden";
        menu.value.style.opacity = toggleMenu.value ? "1" : "0";
      }
      toggleMenu.value = !toggleMenu.value;
    };

    onMounted(() => {
      window.addEventListener("scroll", onScroll);
    });

    onBeforeUnmount(() => {
      window.removeEventListener("scroll", onScroll);
    });

    return {
      menu,
      home,
      showNavbar,
      toggleMenu,
      menuIcons,
      reset,
      toggle,
    };
  },
});
</script>

<style scoped lang="scss">
@media only screen and (min-width: 769px) {
  .wrapper-relative {
    position: relative;
    width: 100vw;
    height: 15vh;
    margin: 0 auto;
  }
  .wrapper-absolute {
    z-index: 1000;
    position: absolute;
    width: 220px;
    position: absolute;
    top: 0;
  }

  .wrapper-fixed {
    position: fixed;
    top: 0px;
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    flex-shrink: 0;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    padding-top: 3vh;
  }

  .title {
    padding-left: 3vw;
    font-size: 1em;
  }

  .menu {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-flow: row nowrap;
    align-items: center;
  }

  .menu-toogle {
    display: none;
  }

  .main-menu {
    display: flex;
    align-items: center;
	padding-right: 3vw;

    &-item {
      font-size: 1em;
	  padding-left: 4vw;
    }
  }
}
@media only screen and (max-width: 768px) {
  .wrapper-relative {
    position: relative;
    width: 100vw;
    height: 100px;
    z-index: 1;
  }

  .wrapper-absolute {
    z-index: 1;
    position: absolute;
    width: 150px;
    position: absolute;
    top: 0;
  }

  .wrapper-fixed {
    z-index: 1;
    position: fixed;
    top: 0px;
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    flex-shrink: 0;
    justify-content: space-between;
    align-items: center;
    background-color: white;
  }

  body {
    overflow-x: hidden;
  }
  .menu-toogle {
    display: flex;
    margin: 45px;
    align-items: center;
  }

  .menu {
    z-index: -1;
    position: absolute;
    right: 0px;
    height: 100vh;
    top: 0vh;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s, opacity 0.2s;
  }

  .title {
    margin: 5vw;
    font-size: 1em;
  }

  .menu-item {
    flex: 0 1;
    margin: 30px;
    font-size: 1em;
  }
}
</style>
